import awsconfig from '@/amplifyconfiguration.json';
import {
  CreateFacilityPatientsInput,
  CreateFacilityPatientsMutation,
  GetFacilityPatientsQuery,
  UpdateFacilityPatientsInput,
  UpdateFacilityPatientsMutation
} from '@/API';
import { createFacilityPatients, updateFacilityPatients } from '@/graphql/mutations';
import { getFacilityPatients } from '@/graphql/queries';
import { Amplify } from 'aws-amplify';
import { useCallback } from 'react';
import { executeQuery } from '@/client/graphql';

Amplify.configure(awsconfig);

/**
 * 施設に関する処理をまとめたHooks。
 * @returns
 */
export const useFacilityPatients = () => {
  /**
   * セッションストレージから施設IDを取得する。
   * @returns 施設ID
   */
  /**
   * FacilityPatientsを取得する。
   * @param patientId 患者ID
   * @param id 施設ID
   * @returns FacilityPatients
   */
  const getFacilityPatientsModel = useCallback(async (patientId: string, facilityId: string) => {
    const facilityPatients = await executeQuery<GetFacilityPatientsQuery>(
      getFacilityPatients,
      {
        patientId: patientId,
        facilityId: facilityId
      },
      'userPool'
    );

    return facilityPatients.getFacilityPatients;
  }, []);

  /**
   * FacilityPatientsを登録する。
   * @param params 登録値
   * @returns
   */
  const postFacilityPatientsModel = useCallback(
    async ({
      facilityId,
      patientId,
      vip,
      karteNo,
      memberStatus,
      createdAt,
      updatedAt,
      isFirstVisit
    }: CreateFacilityPatientsInput) => {
      await executeQuery<CreateFacilityPatientsMutation>(
        createFacilityPatients,
        {
          input: {
            patientId,
            facilityId: facilityId,
            vip,
            karteNo,
            memberStatus,
            createdAt,
            updatedAt,
            isFirstVisit
          }
        },
        'userPool'
      );
    },
    []
  );

  /**
   * FacilityPatientsを更新する。
   * @param params 更新値
   * @returns
   */
  const putFacilityPatientsModel = useCallback(
    async ({
      patientId,
      facilityId,
      vip,
      karteNo,
      memberStatus,
      createdAt,
      updatedAt
    }: UpdateFacilityPatientsInput) => {
      if (!facilityId) throw Error('Not Select facilityId.');
      await executeQuery<UpdateFacilityPatientsMutation>(
        updateFacilityPatients,
        {
          input: {
            patientId,
            facilityId: facilityId,
            vip,
            karteNo,
            memberStatus,
            createdAt,
            updatedAt
          }
        },
        'userPool'
      );
    },
    []
  );

  return {
    getFacilityPatientsModel,
    postFacilityPatientsModel,
    putFacilityPatientsModel
  };
};
